<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
        ></dx-grid>
        <v-dialog v-model="importStudentsDialog" max-width="400">
            <v-card class="pa-2">
                <div>
                    <v-card-title class="headline"
                        >Import Students</v-card-title
                    >
                    <v-layout row class="my-3">
                        <div class="font-weight-medium mr-2 mt-2 title">
                            Students ({{ students.length }})
                        </div>
                        <v-btn
                            class="mb-2 mt-0"
                            @click="clearNumbers"
                            small
                            color="success"
                            ><v-icon dark left>mdi-close-circle</v-icon>Clear
                            List</v-btn
                        >
                    </v-layout>
                    <v-layout row>
                        <div class="font-weight-regular" style="width: 35%">
                            Number
                        </div>
                        <div class="font-weight-regular" style="width: 35%">
                            Account ID
                        </div>
                        <div class="font-weight-regular" style="width: 35%">
                            Name
                        </div>
                        <div class="font-weight-regular" style="width: 35%">
                            Hebrew Name
                        </div>
                        <div class="font-weight-regular" style="width: 15%">
                            Phone Type
                        </div>
                        <div style="min-width: 10%"></div>
                        <!-- <v-btn
                                class="mt-0 pt-0"
                                style="width: 10%"
                                flat
                                icon
                                color="success"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn> -->
                    </v-layout>
                    <v-divider class="mb-2"></v-divider>
                    <div>
                        <div v-for="(student, index) in studentsToDisplay">
                            <v-layout row>
                                <!-- <v-checkbox
                                    class="mt-0 pt-0"
                                    style="max-width: 40px;"
                                    v-model="number.selected"
                                    color="success"
                                    hide-details
                                ></v-checkbox> -->
                                <div style="width: 35%">
                                    {{ student.childFirst }}
                                </div>
                                <div style="width: 35%">
                                    {{ student.childLast }}
                                </div>
                                <div style="width: 35%">
                                    {{ student.birthday | date }}
                                </div>
                                <div style="width: 35%">
                                    {{ student.address1 }}
                                </div>
                                <div style="width: 15%">
                                    {{ student.address2 }}
                                </div>
                                <div style="width: 15%">
                                    {{ student.familyPrimaryPhone }}
                                </div>
                                <div style="width: 15%">
                                    {{ student.father }}
                                </div>
                                <div style="width: 15%">
                                    {{ student.mother }}
                                </div>
                            </v-layout>
                            <v-divider
                                class="mb-2"
                                v-if="index + 1 < students.length"
                            ></v-divider>
                        </div>
                    </div>
                    <!-- <v-layout justify-center class="mt-3 mb-1">
                            <v-pagination
                                v-model="pagination.page"
                                :length="pages"
                                :total-visible="5"
                                v-on:input="setPagianation"
                            ></v-pagination>
                        </v-layout> -->

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            @click="importStudentsDialog = false"
                            >Cancel</v-btn
                        >
                        <v-btn dark color="success" @click="importStudents">
                            Import
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    data: () => ({
        title: "HS Students",

        actions: [],
        userBranch: "",
        url: "",
        regID: "",

        importStudentsDialog: false,
        students: [],
        studentsToDisplay: [],

        pagination: {
            totalCount: 0,
            rowsPerPage: 13,
            page: 1,
        },

        columns: [
            {
                label: "Eng Name",
                field: "engName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Heb Name",
                field: "hebName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Father",
                field: "nameH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "familyID",
                label: "Account ID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Registered On",
                field: "date",
                visible: false,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },

            {
                label: "DOB",
                field: "dob",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Start Date",
                field: "startDate",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grade",
                field: "class",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address1",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cell Phone",
                field: "cellPhone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Is New Family",
                field: "isNewFamily",
                type: "boolean",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    async created() {
        this.columns.find(
            (c) => c.field == "familyID"
        ).showLink = this.showLink;
    },
    beforeDestroy() {},
    methods: {
        async beforeSetupGrid() {
            this.userBranch = this.$store.state.authentication.branch;

            this.actions.push({
                text: "Register Student",
                action: this.register,
            });

            // this.actions.push({
            //     text: "Import Students",
            //     action: this.openImportStudents,
            // });

            this.url = "newStudents?isHS=true";
        },
        showLink() {
            return (
                !this.$store.state.authentication.branch ||
                this.$store.state.authentication.branch == "null"
            );
        },
        register() {
            this.$router.push({
                name: "RegisterHS",
            });
        },
        openImportStudents() {
            this.importStudentsDialog = true;
        },
        async importStudents() {},
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
</style>
